// @ts-nocheck

export const localeCodes =  [
  "fr",
  "en"
]
export const localeLoaders = {
  fr: [
    {
      key: "locale_fr_46json_0524f39c",
      load: () => import("#nuxt-i18n/0524f39c" /* webpackChunkName: "locale_fr_46json_0524f39c" */),
      cache: true
    },
    {
      key: "locale_fr_46json_fcd97db3",
      load: () => import("#nuxt-i18n/fcd97db3" /* webpackChunkName: "locale_fr_46json_fcd97db3" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_db2ff655",
      load: () => import("#nuxt-i18n/db2ff655" /* webpackChunkName: "locale_en_46json_db2ff655" */),
      cache: true
    },
    {
      key: "locale_en_46json_fd9aad69",
      load: () => import("#nuxt-i18n/fd9aad69" /* webpackChunkName: "locale_en_46json_fd9aad69" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "fr",
    iso: "fr-FR",
    name: "French",
    dir: "ltr",
    language: "fr-FR"
  },
  {
    code: "en",
    iso: "en-US",
    name: "English",
    dir: "ltr",
    isCatchallLocale: true,
    language: "en-US"
  }
]

